<template>
  <v-dialog
    persistent
    max-width="600"
    value="visible"
  >
    <v-card>
      <v-container
        fluid
        class="text-center d-flex flex-column justify-center pa-4 pt-4"
      >
        <p class="modal-heading subtitle-1 d-flex font-weight-bold navy-dark--text ma-sm-0 mt-md-6 mb-md-4">
          <v-icon
            large
            color="primary"
            x-large
            :size="24"
            class="mb-1"
          >
            mdi-clock-fast
          </v-icon>
          <span>To save you time & effort, our clever system has automatically created this quote for you using
            last year's details!</span>
        </p>
        <p class="navy-dark--text mb-8 mb-sm-2 mb-md-8 px-6">
          To calculate this year’s quote we’ve added 1 year to the following:
        </p>
        <v-row
          class="mx-0 mb-md-6"
        >
          <v-col
            v-for="(row, index) in modalContent.rows"
            :key="row"
            class="d-flex flex-column justify-space-between"
            :cols="getColWidth(index)"
          >
            <b class="d-block">{{ row }}</b>
            <v-icon
              large
              color="primary"
              class="mb-1"
            >
              mdi-check
            </v-icon>
          </v-col>
        </v-row>
        <template
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <p
            class="body-2 px-8 navy-dark--text mb-6"
          >
            To continue with the quote & to see a summary of your details, please click '<b>View Quote</b>'.
          </p>
          <p class="body-2 navy-dark--text">
            If any of your details have changed since last year, e.g. you may have had {{ modalContent.detailsMsg }}, please click  '<b>Edit Quote</b>':
          </p>
        </template>

        <v-card-actions
          class="mb-0 mb-sm-2 mb-md-8 pt-sm-0 pt-md-1 flex-column flex-sm-row justify-center"
        >
          <div
            class="col-12 col-sm-6 pb-3 pb-sm-0 pa-0"
          >
            <v-btn
              x-large
              color="primary"
              rounded
              class="mt-sm-2 pt-0 col-sm-8"
              @click="viewQuote"
            >
              View Quote
            </v-btn>
          </div>
          <div
            class="col-12 col-sm-6 pa-0 mb-3 mb-sm-0"
          >
            <v-btn
              x-large
              class="mt-sm-2 col-sm-8"
              rounded
              @click="editQuote"
            >
              Edit Quote
            </v-btn>
          </div>
        </v-card-actions>
        <p
          v-if="$vuetify.breakpoint.mdAndUp"
          class="caption"
        >
          <u>Please note</u>: Any inaccuracies could invalidate your policy or see future claims rejected, so we
          would recommend checking your details before purchasing.
        </p>
        <p
          v-else
          class="caption"
        >
          <u>Please note</u>: Any inaccuracies (such as a change in your details since last year) could invalidate your policy or
          see future claims rejected, so we would recommend checking your details before purchasing.
        </p>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import useModalAutoquoteContent from '@/composables/useModalAutoquoteContent';

export default {
  name: 'modal-autoquote',
  props: {
    formData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    viewQuote () {
      this.$api.autoquoteConfirm(this.$route.params.sid);

      this.$emit('click-view-quote');
    },
    editQuote () {
      this.$emit('click-edit-quote');
    },
    getColWidth (index) {
      if (this.modalContent.rows.length === 2) {
        return 6;
      }
      return index === 1 ? 6 : 3;
    },
  },
  setup (props) {
    return {
      ...useModalAutoquoteContent(props),
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-heading {
  .v-icon {
    font-size: 64px !important;
  }
}
</style>
